import { useEffect, useState } from 'react'
import { API } from '../../api'
import { TLogic } from '../../type'

export const useGetLogics = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [logicList, setLogicList] = useState<TLogic[]>([])
  const [originalLogicList, setOriginalLogicList] = useState<TLogic[]>([])

  const getLogicList = async () => {
    setIsLoading(true)
    try {
      const list = await API.CategoryClassification.listLogic()
      setLogicList(list)
      setOriginalLogicList(list)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getLogicList()
  }, [])

  return {
    logicList,
    originalLogicList,
    isLogicListLoading: isLoading,
    setLogicList,
    getLogicList,
    setOriginalLogicList,
  }
}
